import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { useWindowDropGuard } from './shared/util/dropzone'

export default function App() {
  // A file dropped outside a drop zone must never replace the SPA.
  useWindowDropGuard()
  return <RouterProvider router={router} />
}
